/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TipoMangimeDTO } from './TipoMangimeDTO';
import {
    TipoMangimeDTOFromJSON,
    TipoMangimeDTOFromJSONTyped,
    TipoMangimeDTOToJSON,
} from './TipoMangimeDTO';

/**
 * 
 * @export
 * @interface ListinoMangimiDettaglioDTO
 */
export interface ListinoMangimiDettaglioDTO {
    /**
     * 
     * @type {number}
     * @memberof ListinoMangimiDettaglioDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ListinoMangimiDettaglioDTO
     */
    idListino?: number;
    /**
     * 
     * @type {number}
     * @memberof ListinoMangimiDettaglioDTO
     */
    idTipoMangime?: number;
    /**
     * 
     * @type {Date}
     * @memberof ListinoMangimiDettaglioDTO
     */
    inizioValidita?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListinoMangimiDettaglioDTO
     */
    valore?: number;
    /**
     * 
     * @type {TipoMangimeDTO}
     * @memberof ListinoMangimiDettaglioDTO
     */
    tipoMangime?: TipoMangimeDTO;
}

/**
 * Check if a given object implements the ListinoMangimiDettaglioDTO interface.
 */
export function instanceOfListinoMangimiDettaglioDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListinoMangimiDettaglioDTOFromJSON(json: any): ListinoMangimiDettaglioDTO {
    return ListinoMangimiDettaglioDTOFromJSONTyped(json, false);
}

export function ListinoMangimiDettaglioDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListinoMangimiDettaglioDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idListino': !exists(json, 'idListino') ? undefined : json['idListino'],
        'idTipoMangime': !exists(json, 'idTipoMangime') ? undefined : json['idTipoMangime'],
        'inizioValidita': !exists(json, 'inizioValidita') ? undefined : (new Date(json['inizioValidita'])),
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
        'tipoMangime': !exists(json, 'tipoMangime') ? undefined : TipoMangimeDTOFromJSON(json['tipoMangime']),
    };
}

export function ListinoMangimiDettaglioDTOToJSON(value?: ListinoMangimiDettaglioDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idListino': value.idListino,
        'idTipoMangime': value.idTipoMangime,
        'inizioValidita': value.inizioValidita === undefined ? undefined : (value.inizioValidita.toISOString()),
        'valore': value.valore,
        'tipoMangime': TipoMangimeDTOToJSON(value.tipoMangime),
    };
}

